import { action, observable } from 'mobx'
import { type IValidationSchema, required, validationContext } from 'validx'
import type { AnswerOptions } from '@/features/legends/editor/entities'
import { Types } from '@/features/legends/editor/ryno-types'
import {
  QuestionEditorViewModelBase,
  type QuestionEditorViewModelOptions,
} from '@/features/legends/questions/QuestionEditorViewModelBase'
import type { TextQuestion } from '@/features/legends/questions/questions'

/**
 * A question answered with text.
 */
export class TextQuestionEditorViewModel extends QuestionEditorViewModelBase<TextQuestion> {
  private readonly _schema: IValidationSchema<TextQuestionEditorViewModel> = {
    ...QuestionEditorViewModelBase.sharedSchema,
    question: [required('Question is required')],
  }

  readonly type = 'Text'

  @observable accessor question = 'New Text Question'
  @observable accessor description = ''

  readonly validation = validationContext(this, this._schema)

  constructor(options: QuestionEditorViewModelOptions) {
    super(options)
    this._validateWhileEditing(this._schema)
  }

  /** @inheritDoc */
  get valueType() {
    return Types.string
  }

  /** @inheritDoc */
  get answerOptions(): AnswerOptions {
    return { type: 'text' }
  }

  /** @inheritDoc */
  get displayText() {
    return this.question
  }

  /** @inheritDoc */
  @action
  hydrate(question: TextQuestion) {
    this._hydrateShared(question)
    this.question = question.question ?? this.question
    this.description = question.description ?? ''
  }

  /** @inheritDoc */
  protected _serialize(): TextQuestion {
    return {
      ...this._serializeShared(),
      type: this.type,
      question: this.question,
      description: this.description,
    }
  }
}
